import { EventContext, Fields } from '@vimeo/bigpicture-client';

export const venueBpContextName = 'venue_context';
export const venueBpContextSchemaVersion = 2;
export type VenueBpContext = Fields<typeof venueBpContextName, typeof venueBpContextSchemaVersion>;

export const buildVenueBpContext = (fields: VenueBpContext) => {
  return {
    venue_context: new EventContext(venueBpContextName, venueBpContextSchemaVersion, {
      ...fields,
    }),
  };
};
